import axios, { AxiosRequestConfig } from 'axios';

import env from '@/env';

import { ResBase } from './type';

// 배포 환경에서 console.log, console.warn 지우기
if (env.REACT_APP_NO_LOG === 'true') {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noConsole = () => {};
  console.log = noConsole;
  console.warn = noConsole;
  console.error = noConsole;
  console.debug = noConsole;
}

/*
  Axios instance setting
  TODO(stones): Configuration, MiddleWare 필요하면 추가.
*/
const instance = axios.create({
  baseURL: env.REACT_APP_HOST,
  timeout: 15000,
});

export const commonGetRequest = async <T = any, R = any>(
  uri: string,
  params?: T,
  config?: Omit<AxiosRequestConfig<any>, 'params'>,
): Promise<ResBase<R>> => {
  try {
    const { data, status, headers } = await instance.get(uri, { params, ...config });

    const result: ResBase = {
      statusCode: status,
      resData: data,
      header: headers,
    };

    return result;
  } catch (e: any) {
    const { response } = e;
    const result: ResBase = {
      statusCode: response.status,
      resData: response.data,
    };
    return result;
  }
};

export const commonPostRequest = async <T = any, R = any>(
  uri: string,
  body?: T,
  config?: AxiosRequestConfig,
): Promise<ResBase<R>> => {
  try {
    const response = await instance.post(uri, body, config);

    const result: ResBase = {
      statusCode: response.status,
      resData: response.data,
      header: response.headers,
    };

    return result;
  } catch (e: any) {
    const { response } = e;

    if (response === null) {
      const result: ResBase = {
        statusCode: 401,
        resData: '',
      };

      return result;
    }
    const result: ResBase = {
      statusCode: response?.status,
      resData: response?.data,
    };
    return result;
  }
};

export const commonPutRequest = async <T>(uri: string, body?: T, config?: AxiosRequestConfig) => {
  try {
    const response = await instance.put(uri, body, config);

    const result: ResBase = {
      statusCode: response.status,
      resData: response.data,
      header: response.headers,
    };

    return result;
  } catch (e: any) {
    const { response } = e;

    if (response === null) {
      const result: ResBase = {
        statusCode: 401,
        resData: '',
      };

      return result;
    }
    const result: ResBase = {
      statusCode: response.status,
      resData: response.data,
    };

    return result;
  }
};

export const commonDeleteRequest = async <T>(uri: string, params?: T) => {
  try {
    const { data, status, headers } = await instance.delete(uri, { params });

    console.log(headers);

    const result: ResBase = {
      statusCode: status,
      resData: data,
      header: headers,
    };

    return result;
  } catch (e: any) {
    const { response } = e;
    const result: ResBase = {
      statusCode: response.status,
      resData: response.data,
    };
    return result;
  }
};

export default instance;
